/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-11 13:15:38
 */
export default {
  path: '/orgWorkbench',
  name: '承办方控制台',
  hidden: true,
  component: () => import('@/views/OrganizerWorkbench.vue'),
  meta: {
    title: '承办方控制台',
    icon: 'fa fa-university iconTitle'
  },
  redirect: '/orgWorkbench/index/:id',
  children: [
    {
      path: 'index/:id/:tab?',
      name: 'index',
      component: () => import('@/components/organizerComponents/OrganizerHomepage.vue')
    },
    {
      path: 'matchSetting',
      name: '活动设置',
      hidden: true,
      meta: { title: '活动设置' },
      component: resolve =>
        require(['@/views/compmanage/activity/match-setting'], m => resolve(m.default)),
      redirect: '/orgWorkbench/matchSetting/matchBaseSetting',
      children: [
        {
          path: 'matchBaseSetting',
          name: '基本设置',
          hidden: true,
          meta: { title: '基本设置' },
          component: resolve =>
            require(['@/views/compmanage/activity/basicSetting'], m => resolve(m.default))
        },
        {
          path: 'linkSetting',
          name: '活动环节设置',
          hidden: true,
          meta: { title: '活动环节设置' },
          component: resolve =>
            require(['@/views/compmanage/activity/linkSetting'], m => resolve(m.default))
        },
        {
          path: 'activitySignUpSettings',
          name: '报名设置',
          hidden: true,
          meta: { title: '报名设置' },
          component: resolve =>
            require(['@/views/compmanage/activity/signupSetting'], m => resolve(m.default))
        },
        {
          path: 'activitySignUpSettings',
          name: '报名表编辑',
          hidden: true,
          meta: { title: '报名表编辑' },
          component: resolve =>
            require(['@/views/compmanage/activity/editSetting'], m => resolve(m.default))
        },
        {
          path: 'materialSetting',
          name: '材料设置',
          hidden: true,
          meta: { title: '材料设置' },
          component: resolve =>
            require(['@/views/compmanage/activity/materialSetting'], m => resolve(m.default))
        },
        {
          path: 'matchLiveSetting',
          name: '现场比赛设置',
          hidden: true,
          meta: { title: '现场比赛设置' },
          component: resolve =>
            require(['@/views/compmanage/activity/liveSetting/index.vue'], m => resolve(m.default))
        },
        {
          path: 'scoringSetting',
          name: '计分设置',
          hidden: true,
          meta: { title: '计分设置' },
          component: resolve =>
            require(['@/views/compmanage/activity/scoringSetting'], m => resolve(m.default))
        }
      ]
    },
    {
      path: 'notice/:activityId',
      name: '公告',
      hidden: true,
      meta: { title: '公告' },
      component: resolve =>
        require(['@/views/compmanage/notice/NoticeList.vue'], m => resolve(m.default))
    },
    {
      path: 'createNotice/:activityId',
      name: '新建公告',
      hidden: true,
      meta: { title: '新建公告' },
      component: resolve =>
        require(['@/views/compmanage/notice/CreateNotice.vue'], m => resolve(m.default))
    },
    {
      path: 'noticeDetail/:activityId',
      name: '公告详情',
      hidden: true,
      meta: { title: '公告详情' },
      component: resolve =>
        require(['@/views/compmanage/notice/NoticeDetail.vue'], m => resolve(m.default))
    },
    {
      path: 'progressManage/:id',
      name: 'progressManage',
      hidden: true,
      meta: {
        title: '进程管理'
      },
      component: resolve => require(['@/views/compmanage/progressManage'], m => resolve(m.default))
    },
    {
      path: 'activityImages/:id',
      name: '上传图片',
      meta: {
        title: '上传图片'
      },
      component: () => import('@/views/compmanage/activityImages')
    },
    {
      path: 'liveManage/:id',
      name: 'liveManage',
      hidden: true,
      component: () => import('@/views/compmanage/live'),
      meta: {
        title: '直播控制台'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/route-organizer.js